import { push, replace } from 'react-router-redux';

export const gotoHome = () => push('/home');
export const gotoLogin = () => replace('/');

export const gotoNewPatient = () => push('/patients/new_patient');


/** WEBPACK FOOTER **
 ** ./src/actions/redirect.js
 **/